module.exports = __webpack_public_path__ + "img/icon_bill.fd5d07cd.png";